import { render } from "./EmergencyContactList.vue?vue&type=template&id=a0f5df18&scoped=true&ts=true"
import script from "./EmergencyContactList.vue?vue&type=script&lang=ts"
export * from "./EmergencyContactList.vue?vue&type=script&lang=ts"

import "./EmergencyContactList.vue?vue&type=style&index=0&id=a0f5df18&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3687640787/src/biomass-frontend-pwc/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0f5df18"]])

export default __exports__